import { usePlatformGet } from '@reapitform/hooks'
import { IDocuments } from '@reapitform/dashboard-ui'

export enum displayViewMap {
  'welcome' = 10,
  'step' = 20,
  'submitted' = 30,
  'inactiveLink' = 40,
  'changeRequest' = 50,
  'error' = 99,
}

export const getAgreementDetailQueryKey = (documentId?: string) => [`document-detail-${documentId}`]

export const useAgreementDetail = (agreementId?: string) => {
  const [data, isLoading, errorString, refetch, isRefetching, clearCache] = usePlatformGet<IDocuments>({
    path: `/api/User/Document/${agreementId}`,
    queryKeys: getAgreementDetailQueryKey(agreementId),
    fetchWhenTrue: [agreementId !== undefined],
  })

  return {
    data,
    isLoading,
    errorString,
    refetch,
    isRefetching,
    clearCache,
    isError: Boolean(errorString),
  }
}
